/* Zocker — Wishlist, Compare, Quick Shop, AJAX Cart */
(function() {
  'use strict';

  /* ═══ STORAGE HELPERS ═══ */
  function getStore(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch(e) { return []; } }
  function setStore(key, val) { localStorage.setItem(key, JSON.stringify(val)); }
  function escAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ═══ MONEY ═══ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ═══ AJAX CART ═══ */
  var Cart = {
    state: null,

    fetch: function() {
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { Cart.state = c; Cart.render(); return c; });
    },

    add: function(variantId, qty, opts) {
      qty = qty || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function(r) {
        if (!r.ok) {
          return r.json().then(function(err) {
            console.error('[zocker] cart/add error:', r.status, err);
            throw err;
          });
        }
        return r.json();
      }).then(function() {
        Cart.open();
        return Cart.fetch();
      });
    },

    update: function(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); }).then(function(c) { Cart.state = c; Cart.render(); return c; });
    },

    remove: function(key) { return Cart.update(key, 0); },

    open: function() {
      var drawer = document.getElementById('cart-drawer');
      var overlay = document.getElementById('cart-drawer-overlay');
      if (!drawer) return;
      overlay.classList.remove('hidden');
      drawer.classList.remove('translate-x-full');
      var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarW + 'px';
      document.body.style.overflow = 'hidden';
      if (!Cart.state) {
        var items = document.getElementById('cart-drawer-items');
        if (items) items.innerHTML = '<div class="py-12 text-center"><div class="inline-block w-6 h-6 border-2 border-neutral-300 border-t-black rounded-full animate-spin"></div></div>';
      }
    },

    close: function() {
      var drawer = document.getElementById('cart-drawer');
      var overlay = document.getElementById('cart-drawer-overlay');
      if (!drawer) return;
      overlay.classList.add('hidden');
      drawer.classList.add('translate-x-full');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    },

    render: function() {
      var c = Cart.state;
      if (!c) return;
      var badge = document.getElementById('cart-count-badge');
      if (badge) {
        badge.textContent = c.item_count;
        if (c.item_count > 0) badge.classList.remove('hidden'); else badge.classList.add('hidden');
      }
      var items = document.getElementById('cart-drawer-items');
      var total = document.getElementById('cart-drawer-total');
      if (total) total.textContent = formatMoney(c.total_price);
      if (!items) return;
      if (c.items.length === 0) {
        items.innerHTML = '<div class="py-12 text-center"><p class="font-mono text-xs text-neutral-500">Your cart is empty.</p><a href="/collections/all" class="mt-4 inline-block bg-[#0A0A0A] text-white font-mono text-[10px] uppercase font-bold tracking-[0.15em] px-6 py-3 hover:bg-neutral-800">Shop Now</a></div>';
        return;
      }
      var html = '<div class="divide-y divide-neutral-200">';
      c.items.forEach(function(item) {
        html += '<div class="py-4 flex gap-3">';
        html += '<a href="' + item.url + '" class="w-20 h-20 bg-neutral-100 flex-shrink-0 overflow-hidden"><img src="' + item.image + '" alt="' + escAttr(item.title) + '" class="w-full h-full object-cover"></a>';
        html += '<div class="flex-1 min-w-0">';
        html += '<a href="' + item.url + '" class="font-mono text-xs font-bold uppercase line-clamp-2 hover:underline">' + item.product_title + '</a>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p class="font-mono text-[10px] text-neutral-500 mt-0.5">' + item.variant_title + '</p>';
        }
        html += '<div class="flex items-center justify-between mt-2">';
        html += '<div class="flex items-center border border-neutral-300">';
        html += '<button onclick="window.ZockerCart.update(\'' + item.key + '\',' + (item.quantity - 1) + ')" class="w-7 h-7 flex items-center justify-center hover:bg-neutral-100"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
        html += '<span class="w-7 h-7 flex items-center justify-center font-mono text-xs font-bold border-x border-neutral-300">' + item.quantity + '</span>';
        html += '<button onclick="window.ZockerCart.update(\'' + item.key + '\',' + (item.quantity + 1) + ')" class="w-7 h-7 flex items-center justify-center hover:bg-neutral-100"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
        html += '</div>';
        html += '<div class="flex items-center gap-2"><span class="font-mono text-xs font-bold">' + formatMoney(item.line_price) + '</span>';
        html += '<button onclick="window.ZockerCart.remove(\'' + item.key + '\')" class="text-neutral-400 hover:text-red-500"><svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></button>';
        html += '</div></div></div></div>';
      });
      html += '</div>';
      items.innerHTML = html;
    }
  };

  window.ZockerCart = Cart;

  /* Pre-fetch cart on page load so drawer opens instantly */
  Cart.fetch();

  /* Intercept all cart forms for AJAX add */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.matches && form.matches('form[action="/cart/add"]')) {
      e.preventDefault();
      var fd = new FormData(form);
      var variantId = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10);
      var btn = form.querySelector('button[type="submit"]');
      var origText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }
      /* Open drawer immediately so user sees feedback */
      Cart.open();
      Cart.add(variantId, qty).then(function() {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        var qs = document.getElementById('quickshop-modal');
        if (qs && !qs.classList.contains('hidden')) { qs.classList.add('hidden'); qs.classList.remove('flex'); }
      }).catch(function(err) {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        Cart.close();
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        if (err && err.status === 422) {
          msg = err.description || 'This product is currently out of stock or unavailable.';
        }
        alert(msg);
      });
    }
  });

  /* ═══ WISHLIST ═══ */
  var WISH_KEY = 'zocker_wishlist';

  function getWishlist() { return getStore(WISH_KEY); }
  function isInWishlist(handle) { return getWishlist().some(function(p) { return p.handle === handle; }); }

  function toggleWishlist(product) {
    var list = getWishlist();
    var idx = list.findIndex(function(p) { return p.handle === product.handle; });
    if (idx > -1) { list.splice(idx, 1); } else { list.push(product); }
    setStore(WISH_KEY, list);
    updateWishlistBadge();
    renderWishlistPage();
    return idx === -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function(p) { return p.handle !== handle; });
    setStore(WISH_KEY, list);
    updateWishlistBadge();
    renderWishlistPage();
  }

  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-btn');
      btn.classList.toggle('is-active', isInWishlist(handle));
    });
  }

  /* ═══ COMPARE ═══ */
  var COMP_KEY = 'zocker_compare';
  var MAX_COMPARE = 4;

  function getCompare() { return getStore(COMP_KEY); }
  function isInCompare(handle) { return getCompare().some(function(p) { return p.handle === handle; }); }

  function addToCompare(product) {
    var list = getCompare();
    if (list.some(function(p) { return p.handle === product.handle; })) {
      openCompareModal();
      return;
    }
    if (list.length >= MAX_COMPARE) { list.shift(); }
    list.push(product);
    setStore(COMP_KEY, list);
    updateCompareBar();
    openCompareModal();
  }

  function removeFromCompare(handle) {
    var list = getCompare().filter(function(p) { return p.handle !== handle; });
    setStore(COMP_KEY, list);
    updateCompareBar();
    if (list.length === 0) closeCompareModal();
  }

  function clearCompare() {
    setStore(COMP_KEY, []);
    updateCompareBar();
    closeCompareModal();
  }

  function openCompareModal() {
    updateCompareBar();
    var m = document.getElementById('compare-modal');
    if (m) { m.classList.remove('hidden'); m.classList.add('flex'); }
    var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarW + 'px';
    document.body.style.overflow = 'hidden';
  }
  function closeCompareModal() {
    var m = document.getElementById('compare-modal');
    if (m) { m.classList.add('hidden'); m.classList.remove('flex'); }
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function updateCompareBar() {
    var items = getCompare();
    var toggle = document.getElementById('compare-toggle');
    if (toggle) {
      toggle.style.display = items.length > 0 ? '' : 'none';
      var countEl = toggle.querySelector('[data-compare-count]');
      if (countEl) countEl.textContent = items.length;
    }
    document.querySelectorAll('[data-compare-btn]').forEach(function(btn) {
      var handle = btn.getAttribute('data-compare-btn');
      btn.classList.toggle('is-active', isInCompare(handle));
    });
    renderComparePanel(items);
  }

  function renderComparePanel(items) {
    var bar = document.getElementById('compare-bar');
    if (!bar) return;
    if (items.length === 0) { bar.innerHTML = ''; return; }
    var html = '<div class="p-6 border-b border-neutral-200 flex items-center justify-between sticky top-0 bg-white z-10">';
    html += '<h3 class="text-2xl uppercase tracking-tighter" style="font-family:Anton,sans-serif">Compare Products (' + items.length + ')</h3>';
    html += '<div class="flex items-center gap-3"><button onclick="window.ZockerFeatures.clearCompare()" class="font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-500 hover:text-red-500">Clear All</button>';
    html += '<button onclick="window.ZockerFeatures.closeCompareModal()" class="p-1 hover:bg-neutral-100"><svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div></div>';
    html += '<div class="overflow-x-auto"><table class="w-full"><thead><tr class="border-b border-neutral-200"><th class="p-4 text-left font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400 w-32">Feature</th>';
    items.forEach(function(item) {
      html += '<th class="p-4 text-center min-w-[200px]"><button onclick="window.ZockerFeatures.removeFromCompare(\'' + item.handle + '\')" class="font-mono text-[9px] text-neutral-400 hover:text-red-500 float-right"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></th>';
    });
    html += '</tr></thead><tbody>';
    html += '<tr class="border-b border-neutral-100"><td class="p-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400 font-bold">Image</td>';
    items.forEach(function(item) {
      html += '<td class="p-4 text-center"><a href="' + item.url + '"><div class="w-36 h-36 mx-auto bg-neutral-100 overflow-hidden hover-lift"><img src="' + item.image + '" alt="' + escAttr(item.title) + '" class="w-full h-full object-cover"></div></a></td>';
    });
    html += '</tr><tr class="border-b border-neutral-100"><td class="p-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400 font-bold">Name</td>';
    items.forEach(function(item) {
      html += '<td class="p-4 text-center"><a href="' + item.url + '" class="font-mono text-xs font-bold uppercase hover:underline">' + escAttr(item.title) + '</a></td>';
    });
    html += '</tr><tr class="border-b border-neutral-100"><td class="p-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400 font-bold">Price</td>';
    items.forEach(function(item) {
      html += '<td class="p-4 text-center font-mono text-lg font-bold">' + item.price + '</td>';
    });
    html += '</tr><tr><td class="p-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400 font-bold">Actions</td>';
    items.forEach(function(item) {
      html += '<td class="p-4 text-center"><div class="flex flex-col items-center gap-2">';
      html += '<button onclick="window.ZockerCart.add(\'' + item.variant_id + '\',1)" class="w-full max-w-[180px] bg-[#D4FF00] text-[#0A0A0A] font-mono text-[9px] uppercase font-bold tracking-[0.15em] py-3 hover:bg-[#BDE600] transition-colors flex items-center justify-center gap-2 action-btn"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> Add to Cart</button>';
      var prodArg = JSON.stringify(item).replace(/"/g, '&quot;');
      html += '<button onclick=\'window.ZockerFeatures.toggleWishlist(' + JSON.stringify(item) + ');this.classList.toggle("is-active")\' class="w-full max-w-[180px] py-2 border border-neutral-300 hover:border-black font-mono text-[9px] uppercase tracking-[0.15em] flex items-center justify-center gap-2 action-btn ' + (isInWishlist(item.handle) ? 'is-active' : '') + '"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"></path></svg> Wishlist</button>';
      html += '</div></td>';
    });
    html += '</tr></tbody></table></div>';
    bar.innerHTML = html;
  }

  /* ═══ QUICK SHOP ═══ */
  var qsState = { product: null, selectedOptions: [], variant: null, imageIndex: 0 };

  function openQuickShop(handle) {
    var modal = document.getElementById('quickshop-modal');
    var content = document.getElementById('quickshop-content');
    if (!modal || !content) return;
    content.innerHTML = '<div class="p-16 text-center"><div class="animate-pulse"><div class="h-8 bg-neutral-200 w-1/2 mx-auto mb-4"></div><div class="h-64 bg-neutral-200"></div></div></div>';
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    fetch('/products/' + encodeURIComponent(handle) + '.js?_t=' + Date.now(), { cache: 'no-store' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(product) {
        qsState.product = product;
        qsState.imageIndex = 0;
        qsState.selectedOptions = (product.variants[0].options || []).slice();
        qsState.variant = product.variants[0];
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) { qsState.variant = product.variants[i]; qsState.selectedOptions = product.variants[i].options.slice(); break; }
        }
        if (product.images && product.images.length > 1) {
          product.images.forEach(function(src) { var pre = new Image(); pre.src = src; });
        }
        try {
          renderQuickShop();
        } catch (renderErr) {
          console.error('[zocker] quickshop render error:', handle, renderErr);
          content.innerHTML = '<div class="p-8 text-center"><p class="font-mono text-xs text-red-500 mb-4">Display error. Please open the full product page.</p><a href="/products/' + encodeURIComponent(handle) + '" class="inline-block bg-[#0A0A0A] text-white font-mono text-[10px] uppercase tracking-[0.15em] px-6 py-3 hover:bg-[#D4FF00] hover:text-[#0A0A0A] transition-colors">View product page</a></div>';
        }
      })
      .catch(function(err) {
        console.error('[zocker] quickshop load error:', handle, err);
        content.innerHTML = '<div class="p-8 text-center"><p class="font-mono text-xs text-red-500 mb-4">Failed to load product.</p><a href="/products/' + encodeURIComponent(handle) + '" class="inline-block bg-[#0A0A0A] text-white font-mono text-[10px] uppercase tracking-[0.15em] px-6 py-3 hover:bg-[#D4FF00] hover:text-[#0A0A0A] transition-colors">View product page</a></div>';
      });
  }

  function closeQuickShop() {
    var modal = document.getElementById('quickshop-modal');
    if (modal) { modal.classList.add('hidden'); modal.classList.remove('flex'); }
  }

  function findMatchingVariant() {
    if (!qsState.product) return null;
    return qsState.product.variants.find(function(v) {
      return v.options.every(function(o, i) { return o === qsState.selectedOptions[i]; });
    });
  }

  function selectQsOption(optIdx, value) {
    qsState.selectedOptions[optIdx] = value;
    qsState.variant = findMatchingVariant() || qsState.product.variants[0];
    renderQuickShop();
  }

  function setQsImage(url) {
    var main = document.getElementById('qs-main-img');
    if (main) main.src = url;
    if (qsState.product && qsState.product.images) {
      var idx = qsState.product.images.indexOf(url);
      if (idx > -1) qsState.imageIndex = idx;
    }
    updateQsThumbs();
  }

  function updateQsThumbs() {
    var container = document.getElementById('qs-thumbs');
    if (!container || !qsState.product) return;
    var imgs = qsState.product.images;
    var page = Math.floor(qsState.imageIndex / 6);
    var start = page * 6;
    var visible = imgs.slice(start, start + 6);
    var currentUrl = imgs[qsState.imageIndex];
    var html = '';
    for (var i = 0; i < 6; i++) {
      var imgUrl = visible[i];
      if (imgUrl) {
        var active = imgUrl === currentUrl;
        html += '<button type="button" data-qs-thumb="' + imgUrl + '" onclick="window.ZockerFeatures.setQsImage(\'' + imgUrl + '\')" class="aspect-square bg-neutral-100 overflow-hidden border-r border-neutral-200 last:border-r-0 ' + (active ? 'opacity-100 ring-2 ring-inset ring-[#D4FF00]' : 'opacity-60 hover:opacity-100') + '" style="width:16.6667%"><img src="' + imgUrl + '" alt="" class="w-full h-full object-cover"></button>';
      } else {
        html += '<div class="aspect-square bg-neutral-50 border-r border-neutral-200 last:border-r-0" style="width:16.6667%"></div>';
      }
    }
    container.innerHTML = html;
  }

  function qsImageNav(dir) {
    if (!qsState.product || !qsState.product.images || qsState.product.images.length < 2) return;
    var imgs = qsState.product.images;
    qsState.imageIndex = (qsState.imageIndex + dir + imgs.length) % imgs.length;
    setQsImage(imgs[qsState.imageIndex]);
  }

  function qsAddToCart() {
    if (!qsState.variant || !qsState.variant.available) return;
    var qty = parseInt((document.getElementById('qs-qty') || {}).value || '1', 10);
    Cart.add(String(qsState.variant.id), qty).then(function() {
      window.ZockerFeatures.closeQuickShop();
    }).catch(function(err) {
      var msg = (err && err.description) || (err && err.message) || 'Unable to add to cart';
      var content = document.getElementById('quickshop-content');
      if (!content) { alert(msg); return; }
      var existing = document.getElementById('qs-error');
      if (existing) existing.remove();
      var banner = document.createElement('div');
      banner.id = 'qs-error';
      banner.className = 'mx-5 mb-3 p-3 bg-red-50 border border-red-200 font-mono text-[10px] text-red-700';
      banner.textContent = msg;
      var btn = content.querySelector('button[onclick*="qsAddToCart"]');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(banner, btn);
      else content.appendChild(banner);
    });
  }

  function renderQuickShop() {
    var content = document.getElementById('quickshop-content');
    if (!content) return;
    var product = qsState.product;
    var variant = qsState.variant;
    var img = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || product.images[0];
    var price = formatMoney(variant.price);
    var comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
    var qty = parseInt((document.getElementById('qs-qty') || {}).value || '1', 10);

    var html = '<div class="flex items-center justify-between p-4 sm:p-5 border-b border-neutral-200 sticky top-0 bg-white z-10">';
    html += '<span class="font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-500">// Quick Shop</span>';
    html += '<button type="button" onclick="window.ZockerFeatures.closeQuickShop()" class="p-1 hover:bg-neutral-100 action-btn"><svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>';
    html += '<div class="grid grid-cols-1 md:grid-cols-2">';

    /* Left: Image slider with arrows */
    html += '<div class="border-b md:border-b-0 md:border-r border-neutral-200">';
    html += '<div class="aspect-square bg-neutral-100 overflow-hidden relative group">';
    html += '<img id="qs-main-img" src="' + img + '" alt="' + escAttr(product.title) + '" class="w-full h-full object-cover">';
    if (comparePrice) html += '<span class="absolute bottom-3 left-3 bg-[#D4FF00] text-[#0A0A0A] font-mono text-[9px] font-bold uppercase tracking-[0.15em] px-3 py-1.5 z-10">Sale</span>';
    if (product.images.length > 1) {
      html += '<button type="button" onclick="window.ZockerFeatures.qsImageNav(-1)" aria-label="Previous image" class="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/90 hover:bg-white border border-neutral-200 flex items-center justify-center shadow opacity-0 group-hover:opacity-100 transition-opacity z-10"><svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></button>';
      html += '<button type="button" onclick="window.ZockerFeatures.qsImageNav(1)" aria-label="Next image" class="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-white/90 hover:bg-white border border-neutral-200 flex items-center justify-center shadow opacity-0 group-hover:opacity-100 transition-opacity z-10"><svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';
    }
    html += '</div>';
    if (product.images.length > 1) {
      html += '<div id="qs-thumbs" class="flex border-t border-neutral-200">';
      for (var ti = 0; ti < 6; ti++) {
        var thumbUrl = product.images[ti];
        if (thumbUrl) {
          var thumbActive = thumbUrl === img;
          html += '<button type="button" data-qs-thumb="' + thumbUrl + '" onclick="window.ZockerFeatures.setQsImage(\'' + thumbUrl + '\')" class="aspect-square bg-neutral-100 overflow-hidden border-r border-neutral-200 last:border-r-0 ' + (thumbActive ? 'opacity-100 ring-2 ring-inset ring-[#D4FF00]' : 'opacity-60 hover:opacity-100') + '" style="width:16.6667%"><img src="' + thumbUrl + '" alt="" class="w-full h-full object-cover"></button>';
        } else {
          html += '<div class="aspect-square bg-neutral-50 border-r border-neutral-200 last:border-r-0" style="width:16.6667%"></div>';
        }
      }
      html += '</div>';
    }
    html += '</div>';

    /* Right: Info */
    html += '<div class="p-5 sm:p-6 md:p-8 flex flex-col">';
    html += '<a href="/products/' + product.handle + '" class="text-2xl sm:text-3xl uppercase tracking-tighter hover:underline leading-none" style="font-family:Anton,sans-serif">' + product.title + '</a>';
    html += '<div class="flex items-baseline gap-2 mt-3"><span class="font-mono text-2xl font-bold">' + price + '</span>';
    if (comparePrice) html += '<span class="font-mono text-sm text-neutral-400 line-through">' + comparePrice + '</span>';
    html += '</div>';
    if (product.description) {
      var desc = product.description.replace(/<[^>]*>/g, '').substring(0, 150);
      html += '<p class="font-mono text-[10px] text-neutral-500 mt-3 line-clamp-2 leading-relaxed">' + desc + '</p>';
    }
    html += '<div class="border-t border-neutral-200 my-4"></div>';

    /* Options — only show if there are real options (not just Default Title) */
    var optNames = product.options.map(function(o) { return typeof o === 'string' ? o : o.name; });
    if (optNames.length > 0 && !(optNames.length === 1 && optNames[0].toLowerCase() === 'title')) {
      optNames.forEach(function(optName, oi) {
        if (optName.toLowerCase() === 'title') return;
        var optValues = [];
        if (product.options_with_values && product.options_with_values[oi]) {
          optValues = product.options_with_values[oi].values || [];
        } else if (typeof product.options[oi] === 'object' && product.options[oi].values) {
          optValues = product.options[oi].values;
        }
        if (!optValues || optValues.length === 0) {
          var seen = {};
          optValues = [];
          product.variants.forEach(function(v) {
            var val = v.options[oi];
            if (val && !seen[val]) { seen[val] = true; optValues.push(val); }
          });
        }
        if (optValues.length === 0 || (optValues.length === 1 && optValues[0] === 'Default Title')) return;

        html += '<div class="mb-4"><span class="font-mono text-[10px] uppercase tracking-[0.15em] font-bold block mb-2">' + optName + ': <span class="text-neutral-500 font-normal">' + (qsState.selectedOptions[oi] || '') + '</span></span><div class="flex flex-wrap gap-1.5">';
        optValues.forEach(function(val) {
          var selected = qsState.selectedOptions[oi] === val;
          var soldOut = !product.variants.some(function(v) {
            if (v.options[oi] !== val) return false;
            for (var j = 0; j < qsState.selectedOptions.length; j++) {
              if (j !== oi && qsState.selectedOptions[j] && v.options[j] !== qsState.selectedOptions[j]) return false;
            }
            return v.available;
          });
          if (optName.toLowerCase() === 'color' || optName.toLowerCase() === 'colour') {
            var swatchImg = '';
            for (var vi = 0; vi < product.variants.length; vi++) {
              var v = product.variants[vi];
              if (v.options[oi] === val && v.featured_image && v.featured_image.src) {
                swatchImg = v.featured_image.src;
                break;
              }
            }
            var bgColor = val.toLowerCase().replace(/\s/g, '');
            var swatchStyle = swatchImg
              ? 'background-image:url(' + swatchImg + ');background-size:cover;background-position:center'
              : 'background-color:' + bgColor;
            var colorCls = selected ? 'border-black scale-110 ring-2 ring-[#D4FF00]' : 'border-neutral-300 hover:scale-105';
            if (soldOut) colorCls += ' opacity-40 qs-soldout-color';
            html += '<button type="button" onclick="window.ZockerFeatures.selectQsOption(' + oi + ',\'' + val.replace(/'/g, "\\'") + '\')" class="relative w-9 h-9 rounded-full border-2 transition-all ' + colorCls + '" style="' + swatchStyle + '" title="' + escAttr(val) + (soldOut ? ' (Sold out)' : '') + '"></button>';
          } else {
            var btnCls = selected ? 'bg-black text-white border-black' : 'border-neutral-300 hover:border-black';
            if (soldOut) btnCls += ' line-through opacity-50';
            html += '<button type="button" onclick="window.ZockerFeatures.selectQsOption(' + oi + ',\'' + val.replace(/'/g, "\\'") + '\')" class="font-mono text-[10px] px-3 py-1.5 border transition-all ' + btnCls + '" title="' + (soldOut ? 'Sold out' : '') + '">' + val + '</button>';
          }
        });
        html += '</div></div>';
      });
    }

    /* Stock indicator */
    if (variant.available) {
      html += '<div class="flex items-center gap-2 mb-3"><span class="w-2 h-2 bg-green-500 rounded-full"></span><span class="font-mono text-[10px] text-green-600 uppercase tracking-[0.15em]">In Stock</span></div>';
    } else {
      html += '<div class="flex items-center gap-2 mb-3"><span class="w-2 h-2 bg-red-500 rounded-full"></span><span class="font-mono text-[10px] text-red-600 uppercase tracking-[0.15em]">Out of Stock</span></div>';
    }

    /* Qty + Add */
    html += '<div class="mt-auto space-y-3 pt-4">';
    html += '<div class="flex items-center gap-3"><span class="font-mono text-[10px] font-bold uppercase tracking-[0.15em]">Qty</span>';
    html += '<div class="flex border border-neutral-300"><button type="button" onclick="var q=document.getElementById(\'qs-qty\');q.value=Math.max(1,parseInt(q.value)-1)" class="w-8 h-8 flex items-center justify-center hover:bg-neutral-100"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg></button>';
    html += '<input id="qs-qty" type="number" value="' + qty + '" min="1" class="w-10 h-8 text-center font-mono text-xs font-bold border-x border-neutral-300 zocker-qty-input">';
    html += '<button type="button" onclick="var q=document.getElementById(\'qs-qty\');q.value=parseInt(q.value)+1" class="w-8 h-8 flex items-center justify-center hover:bg-neutral-100"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg></button></div></div>';

    html += '<button type="button" onclick="window.ZockerFeatures.qsAddToCart()" ' + (variant.available ? '' : 'disabled') + ' class="w-full bg-[#D4FF00] text-[#0A0A0A] font-mono text-[10px] uppercase font-bold tracking-[0.15em] py-4 hover:bg-[#BDE600] transition-colors flex items-center justify-center gap-2 action-btn disabled:opacity-50 disabled:cursor-not-allowed"><svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> Add to Cart &mdash; ' + price + '</button>';

    /* Wishlist + Compare */
    var prodObj = { handle: product.handle, title: product.title, image: img, price: price, url: '/products/' + product.handle, variant_id: String(variant.id) };
    var prodArg = JSON.stringify(prodObj).replace(/"/g, '&quot;');
    html += '<div class="flex gap-2">';
    html += '<button type="button" onclick=\'window.ZockerFeatures.toggleWishlist(' + JSON.stringify(prodObj) + ');this.classList.toggle("is-active")\' class="flex-1 py-3 border border-neutral-300 hover:border-black font-mono text-[10px] uppercase tracking-[0.15em] flex items-center justify-center gap-2 action-btn ' + (isInWishlist(product.handle) ? 'is-active' : '') + '"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"></path></svg> Wishlist</button>';
    html += '<button type="button" onclick=\'window.ZockerFeatures.addToCompare(' + JSON.stringify(prodObj) + ')\' class="flex-1 py-3 border border-neutral-300 hover:border-black font-mono text-[10px] uppercase tracking-[0.15em] flex items-center justify-center gap-2 action-btn"><svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path></svg> Compare</button>';
    html += '</div>';

    /* Trust badges */
    html += '<div class="grid grid-cols-3 border border-neutral-200">';
    html += '<div class="text-center p-2.5 border-r border-neutral-200"><svg class="w-3 h-3 mx-auto text-neutral-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg><p class="font-mono text-[8px] text-neutral-500 mt-0.5 uppercase">Free Shipping</p></div>';
    html += '<div class="text-center p-2.5 border-r border-neutral-200"><svg class="w-3 h-3 mx-auto text-neutral-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg><p class="font-mono text-[8px] text-neutral-500 mt-0.5 uppercase">30-Day Returns</p></div>';
    html += '<div class="text-center p-2.5"><svg class="w-3 h-3 mx-auto text-neutral-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg><p class="font-mono text-[8px] text-neutral-500 mt-0.5 uppercase">Warranty</p></div>';
    html += '</div></div></div></div>';

    content.innerHTML = html;
  }

  /* ═══ WISHLIST PAGE ═══ */
  function renderWishlistPage() {
    var container = document.getElementById('wishlist-grid');
    if (!container) return;
    var items = getWishlist();
    var empty = document.getElementById('wishlist-empty');
    var count = document.getElementById('wishlist-count');
    if (count) count.textContent = items.length;
    if (items.length === 0) {
      container.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    var html = '';
    items.forEach(function(item) {
      if (!item.handle || !item.title) return;
      var img = item.image || '';
      var url = item.url || '/products/' + item.handle;
      var price = item.price || '';
      var varId = item.variant_id || '';
      html += '<div class="group border border-neutral-200 relative">';
      html += '<a href="' + url + '" class="block"><div class="relative bg-neutral-100 overflow-hidden aspect-square">' + (img ? '<img src="' + img + '" alt="' + escAttr(item.title) + '" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy">' : '') + '</div></a>';
      html += '<button onclick="window.ZockerFeatures.removeFromWishlist(\'' + item.handle + '\')" class="absolute top-2 right-2 w-8 h-8 flex items-center justify-center bg-white border border-neutral-200 shadow-sm hover:bg-red-50 hover:border-red-300 transition-colors"><svg class="w-3.5 h-3.5 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>';
      html += '<div class="p-4"><a href="' + url + '"><h3 class="font-mono text-xs font-bold line-clamp-1 hover:underline uppercase">' + escAttr(item.title) + '</h3></a>';
      html += '<p class="font-mono text-sm font-bold mt-2">' + price + '</p>';
      if (varId) html += '<button onclick="window.ZockerCart.add(\'' + varId + '\',1)" class="w-full mt-3 bg-[#0A0A0A] text-white font-mono text-[9px] uppercase tracking-[0.15em] font-bold px-4 py-2 hover:bg-[#D4FF00] hover:text-[#0A0A0A] transition-colors">+ Add to Cart</button>';
      html += '</div></div>';
    });
    container.innerHTML = html;
  }

  /* ═══ INIT ═══ */
  function init() {
    Cart.fetch();
    updateWishlistBadge();
    updateCompareBar();
    renderWishlistPage();

    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        try {
          var data = JSON.parse(btn.getAttribute('data-product-json'));
          var added = toggleWishlist(data);
          btn.classList.toggle('is-active', added);
        } catch (err) { console.error('[zocker] wishlist btn error:', err); }
      });
    });

    document.querySelectorAll('[data-compare-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        try {
          var data = JSON.parse(btn.getAttribute('data-product-json'));
          addToCompare(data);
        } catch (err) { console.error('[zocker] compare btn error:', err); }
      });
    });

    document.querySelectorAll('[data-quickshop-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var handle = btn.getAttribute('data-quickshop-btn');
        openQuickShop(handle);
      });
    });

    /* ESC closes modals */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeQuickShop();
        closeCompareModal();
        Cart.close();
      }
    });
  }

  window.ZockerFeatures = {
    toggleWishlist: toggleWishlist,
    removeFromWishlist: removeFromWishlist,
    addToCompare: addToCompare,
    removeFromCompare: removeFromCompare,
    clearCompare: clearCompare,
    updateCompareBar: updateCompareBar,
    openCompareModal: openCompareModal,
    closeCompareModal: closeCompareModal,
    openQuickShop: openQuickShop,
    closeQuickShop: closeQuickShop,
    selectQsOption: selectQsOption,
    setQsImage: setQsImage,
    qsImageNav: qsImageNav,
    qsAddToCart: qsAddToCart,
    isInWishlist: isInWishlist,
    isInCompare: isInCompare
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
